module.exports = __webpack_public_path__ + "static/media/ABI_Logo_FullColor-Black.1ea1ac54.svg";